import { jsx as _jsx } from "react/jsx-runtime";
import { View } from 'react-native';
import { CoreConfig } from './../../../CoreConfig';
import { component } from '../../Decorators/Component';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { AnimatedScrollView } from './AnimatedScrollView';
const sizes = {
    sm: 400,
    'sm-md': 600,
    md: 700,
    lg: 1090
};
function getShellSize(size) {
    if (!size) {
        return {};
    }
    return {
        maxWidth: sizes[size]
    };
}
export const ShellView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.shell,
    style(theme, mediaQuery, window, props) {
        return {
            container: Object.assign({ flex: 1, alignItems: 'center' }, props.containerStyle),
            shell: Object.assign(Object.assign(Object.assign({ flex: 1, width: '100%', height: '100%', maxWidth: '100%' }, mediaQuery.sm({
                maxWidth: 1090,
            })), getShellSize(props.size)), props.shellStyle),
            shellContent: Object.assign({ minHeight: '100%', padding: 20 }, props.shellContentStyle)
        };
    }
})(({ style, children, scrollViewRef, scrollViewProps }) => {
    return (_jsx(View, { style: style === null || style === void 0 ? void 0 : style.container, children: _jsx(AnimatedScrollView, Object.assign({ scrollViewRef: scrollViewRef, containerStyle: style === null || style === void 0 ? void 0 : style.shell, contentContainerStyle: style === null || style === void 0 ? void 0 : style.shellContent }, scrollViewProps, { children: children })) }));
});
